import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { POPUP_VARIANTS } from '@v4/components/sections/Popup'
import ROUTES from '@v4/constants/route'
import AppStore from '@v4/store/appStore'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageData from '@v4/utils/data/PageData'
import usePopupButton from '@v4/hooks/usePopupButton'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import ScorecardData from '@v4/utils/data/ScorecardData'
import { QUERY_PARAMS_TO_DELETE } from '@v4/constants/general'

export const useSignUpButton = ({ className, children, onClick, editable, onChange, rounded, action, ...rest }) => {
	const signUpLocation = ScorecardSelector.useSignUpLocation()
	const pageType = PageBuilderSelector.useType()
	const basename = AppStore.useStoreState(state => state.general.basename)
	const target = AppStore.useStoreState(state => state.general.targetWindow)
	const { search: locationSearch } = useLocation()

	const search = useMemo(() => {
		const searchParams = new URLSearchParams(locationSearch)

		if (target === '_top') {
			_.forEach(QUERY_PARAMS_TO_DELETE, param => searchParams.delete(param))
		}

		return searchParams.size ? `?${searchParams}` : ''
	}, [locationSearch, target])

	const { handleClick } = usePopupButton(
		PageData.isTypeResult(pageType) ? POPUP_VARIANTS.SING_UP_RESULT : POPUP_VARIANTS.SING_UP_LANDING,
	)

	const isLink = action !== 'open-lead-form' && ScorecardData.isSignUpAfterQuestion(signUpLocation)

	return [
		{
			className,
			children,
			...(isLink
				? {
						component: 'a',
						href: `${basename}${ROUTES.QUESTIONS}${search}`,
						target: target || undefined,
				  }
				: {}),
			editable,
			rounded,
			rest,
		},
		{
			handleClick: isLink ? onClick : handleClick || onClick,
			handleChange: onChange,
		},
	]
}
